import React from 'react';
import './switch.styles.css';

function CustomSwitch({ name, data, setData }) {
  const handleChange = e => {
    setData(preValue => ({ ...preValue, [e.target.name]: e.target.checked }));
  };
  return (
    <div className='pointer-css'>
      <input
        type='checkbox'
        onChange={handleChange}
        name={name}
        id={name}
        checked={data[name]}
        className='checkbox pointer-css'
      />
      <label htmlFor={name} className='toggle'></label>
    </div>
  );
}

export default CustomSwitch;
